<template>
  <PageWrapper @handleBack="goToParvandehList">
    <template>
      <Tabs :tabs="tabs" tabContentClass="overflow-y-hidden">
        <template #tab-0>
          <AddParvandehForNewUser />
        </template>
        <template #tab-1>
          <AddParvandehForActiveUser />
        </template>
      </Tabs>
    </template>
  </PageWrapper>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { PageWrapper, Tabs } from "@/components/re-design";
import AddParvandehForNewUser from "./components/AddParvandehForNewUser.vue";
import AddParvandehForActiveUser from "./components/AddParvandehForActiveUser.vue";
import { goToRoute } from "@/shared/utils";

export default {
  mixins: [inputMixin],
  components: {
    PageWrapper,
    Tabs,
    AddParvandehForNewUser,
    AddParvandehForActiveUser,
  },
  data() {
    return {
      tabs: ["کاربر جدید", "کاربر فعال"],
    };
  },
  methods: {
    goToParvandehList() {
      goToRoute("parvandeh", {}, {}, false);
    },
  },
};
</script>
